import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Logger } from '@gci/helpers/logger';
import { SharedModule } from '../../shared.module';
import { ToastService } from '@gci/components/toast/toast.service';

@Component({
    selector: 'app-dialog',
    standalone: true,
    imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, CommonModule, SharedModule],
    templateUrl: './dialog.component.html',
    styleUrl: './dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {

    // -----------------------------------------------------------------------------------------------------
    // @ Properties
    // -----------------------------------------------------------------------------------------------------
    public title: string;
    public description: string;
    public type: 'validation' | 'show';
    public id: string;

    private dialogRef = inject(MatDialogRef<DialogComponent>);
    private data = inject(MAT_DIALOG_DATA);
    private _logger = new Logger('DialogComponent');
    private _toastService = inject(ToastService);


    // -----------------------------------------------------------------------------------------------------
    // @ Constructor
    // -----------------------------------------------------------------------------------------------------
    constructor() {
        this.title = this.data.title;
        this.description = this.data.description;
        this.type = this.data.type;
        this.id = this.data.id;
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Copy the data into clipboard
     */
    onCopy() {
        navigator.clipboard.writeText(this.id).then(() => {
            this._toastService.info("ID Copied");
        })
    }

    /**
     * Return the data true
     */
    onYes() {
        this.dialogRef.close(true);
    }
}
